import script from "./document-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./document-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__